(function() {
'use strict';

angular
    .module('TR')
    .service('flightSearch', flightSearch);

function flightSearch(
    preferences,
    unadjustedDateFilter,
    sortCriteria,
    $http,
    dateUtil,
    analytics,
    occupancyService,
    flightSearchValidator,
    baggageService,
    flightDetail,
    searchUnitService,
    FilterUtils,
    arrayUtil,
    $q,
    broker,
    cancellerService,
    tripService,
    currentDestination,
    $routeParams,
    $window,
    $rootScope) {
    const url = '/api2/flights/availability/';
    const webUrl = 'website/flights/';
    const staticUrl = '/api2/flights/static';
    let results;
    let inProgress;
    let filterCanceller;
    let filterDefer = $q.defer();
    const sortCriteriaDef = sortCriteria.getFlightCriteria();
    let filterUtil = new FilterUtils(_defaultFilterCriteria());

    const req = {
        Paging: {
            PageIndex: 0,
            PageSize: 10
        },
        OneWayOnly: false,
        NumberOfLeadBags: 0,
        WaitForResults: true
    };

    // Stop when clicking the back/forward buttons, the filters need to be cleared
    // because the next page might have completely different search results.
    $($window).on('popstate', () => {
        if (req.AvailabilitySearchId) {
            resetFilters();
        }
    });

    preferences.getFlightSortOrder(true).then(function(so) {
        req.SortCriterion = so;
    });

    const service = {
        clearSearchResults,
        filter,
        filterSet,
        getAirportTitles,
        getAvailabilityRequest,
        getFilter,
        getFilterLazy,
        getFlightsForDeals,
        getOccupancySummary,
        getRouteSummary,
        getSearchResults,
        getSearchSummary,
        getSortCriteria,
        getSortCriterionDescription,
        getUrl,
        rehydrateMultiDestHolidayFlight,
        setBags,
        modifyBags,
        nextPage,
        pageSize,
        rangeFilterSet,
        removeArrayFilter,
        resetArrayFilter,
        resetBooleanFilter,
        resetFilters,
        resetPageIndex,
        resetRangeFilter,
        search,
        setCabin,
        sort,
        validateSearchCriteria,
        trackFlightClick
    };

    function resetPageIndex() {
        req.Paging.PageIndex = 0;
        if (results) {
            results.CombinedDates.AvailableFlights = results.CombinedDates.AvailableFlights.slice(0, req.Paging.PageSize);
        }
    }

    function _emptyFilterCriteria() {


        const disableOpenJawPublicMode = TRPCONFIG.Domain2.DisableOpenJawPublicMode;
        const disableOpenJawAgentMode = TRPCONFIG.Domain2.DisableOpenJawAgentMode;
        const HideOpenJaw = TRPCONFIG.Domain.isAgentMode
        ? disableOpenJawAgentMode : !TRPCONFIG.Domain.isAgentMode
        ? disableOpenJawPublicMode : false;

        return {
            DepartureDates: [],
            DepartureAirport: [],
            Airline: [],
            Stop: [],
            PriceRange: null,
            OutboundTakeOffRange: null,
            ReturnTakeOffRange: null,
            HideOpenJaw
        };
    }

    function _defaultFilterCriteria() {
        const newFilter = _emptyFilterCriteria();

        if (_.get(req, 'FilterCriteria.DepartureDates.length') > 0) {
            newFilter.DepartureDates = req.FilterCriteria.DepartureDates.slice(); //copy values over
        }

        return newFilter;
    }

    function _getFilterCriteriaSet() {
        //when filtering we should only pass the items a user has set, but we also want to
        //take care to not modify the actual filter object, so return a modified
        //copy of the filter
        const filterCopy = angular.copy(getFilter());
        if (results != null) {
            filterUtil.setToNullIfMatches(filterCopy, 'PriceRange', results.CombinedDates.UnfilteredAggregates);
            filterUtil.setToNullIfMatches(filterCopy, 'OutboundTakeOffRange', results.CombinedDates.UnfilteredAggregates);
            filterUtil.setToNullIfMatches(filterCopy, 'ReturnTakeOffRange', results.CombinedDates.UnfilteredAggregates);
        }
        return filterCopy;
    }

    const enableFlightPreselectionApi = TRPCONFIG.Domain2.EnableFlightPreselectionApi ? 'searchfromsessionwithprioritypreselection' : 'searchfromsession';

    function _getUrl(newSearch) {
        return newSearch ?
            `${webUrl}search` :
            `${webUrl}${enableFlightPreselectionApi}`;
    }

    function _resetFlexibleDates(req) {
        // If DepartureDates are emty we will get the responce +-3 days using this reqest.
        // Here we use only one date from search by default so dates wil not be flexible.
        // But if user will change the date using checkbox in departure date fliter we will use dates which was choosen.
        if (req.FilterCriteria.DepartureDates === undefined || req.FilterCriteria.DepartureDates.length === 0) {
            req.FilterCriteria.DepartureDates = [unadjustedDateFilter(searchUnitService.startDate(), 'yyyy-MM-dd')];
        } else if (req.FilterCriteria.DepartureDates.length === 1) {
            req.FilterCriteria.DepartureDates = getFilter().DepartureDates;
        }
        return req;
    }

    function getFlightsForDeals(id, checkIn, checkOut, destAirports, depAirports) {
        const api = `${url}getflightsfordeal`;
        const req = {
            AvailabilitySearchId: id,
            DomainId: TRPCONFIG.Domain.DomainId,
            CheckInDate: dateUtil.serialiseDate(checkIn),
            CheckOutDate: dateUtil.serialiseDate(checkOut),
            DepartureAirports: depAirports,
            DestinationAirports: destAirports,
            FlightsCount: 3
        };

        return $http.post(api, req)
            .then(res => {
                if (!res.data || !res.data.Flights) { return []; }
                return res.data.Flights;
            });
    }

    function getAirportTitles(codes) {
        const params = {
            AirportCodes: codes,
            CultureCode: TRPCONFIG.Domain.CultureCode
        };
        let url = `${staticUrl}/gettitles?${jQuery.param(params)}`;
        return $http.get(url, { cache: true });
    }

    function getSortCriteria(oneWay) {
        return sortCriteria.getFlightCriteria(oneWay);
    }

    function getSortCriterionDescription() {
        return preferences.getFlightSortOrder().then(function(so) {
            const i = arrayUtil.indexOf(sortCriteriaDef, function(c) {
                return c.val === so || (angular.isArray(c.val) && c.val.indexOf(so) !== -1);
            });
            return i >= 0 ? sortCriteriaDef[i].name() : '';
        });
    }

    function getFilter() {
        return filterUtil.getFilter();
    }

    function getFilterLazy() {
        return filterDefer.promise;
    }

    function filterSet(filterName) {
        return filterUtil.filterSet(filterName);
    }

    function _resetPriceRange(results) {
        filterUtil.resetRangeFilter(results, results.CombinedDates.UnfilteredAggregates, 'PriceRange', ['Min', 'Max']);
    }

    function resetFilters(dontApply) {
        filterUtil = new FilterUtils(_emptyFilterCriteria());
        filterDefer = $q.defer();
        if (!dontApply) {
            return service.filter();
        }
        return $q.when();
    }

    function rangeFilterSet(filterName, range) {
        return filterUtil.rangeFilterSet(results, results.CombinedDates.UnfilteredAggregates, filterName, range);
    }

    function resetRangeFilter(filterName, range) {
        filterUtil.resetRangeFilter(results, results.CombinedDates.UnfilteredAggregates, filterName, range);
        return service.filter();
    }

    function removeArrayFilter(filterName, item) {
        filterUtil.removeArrayFilter(filterName, item);
        return service.filter();
    }

    function resetBooleanFilter(filterName) {
        filterUtil.resetBooleanFilter(filterName);
        return service.filter();
    }

    function resetArrayFilter(filterName) {
        filterUtil.resetArrayFilter(filterName);
        return service.filter();
    }

    function getRouteSummary(tripType, tripId) {
        return $q.all([
            currentDestination.getCurrentDestination(),
            tripService.getSelectedDestinationAirport(tripId)
        ]).then(function(res) {
            const [dest, destAirport] = res;
            let to;
            if ((dest == null || tripType === 1) && destAirport) {     //if it's flight only we should always use the destination airport
                to = destAirport.ShortTitle || destAirport.Title;
            } else if (dest) {
                to = dest.SummaryTitle;
            }
            return to;
            //return to ? 'Flights to ' + to : 'Flights';
        });
    }

    function getOccupancySummary() {
        return occupancyService.getRoomOccupancyString();
    }

    function getSearchSummary(tripType, tripId) {
        // TODO: use formatted resource string
        //return getRouteSummary() + ' on ' + getDurationSummary() + ', ' + getOccupancySummary();
        return $q.all([
            getRouteSummary(tripType, tripId),
            tripService.getDurationSummary(searchUnitService.flight, $routeParams.tripId)
        ]).then(result => `${result[0]} on ${result[1]}`);
    }

    function validateSearchCriteria(isHoliday, oneWayOnly) {
        return flightSearchValidator.validate(
            isHoliday,
            searchUnitService.getDestination(),
            searchUnitService.getDestinationAirport(),
            searchUnitService.getDepartureAirports(),
            searchUnitService.startDate(searchUnitService.flight),
            searchUnitService.endDate(searchUnitService.flight),
            searchUnitService.getOutboundDates(searchUnitService.flight),
            searchUnitService.getCabin(),
            occupancyService.getOccupancy(),
            oneWayOnly
        );
    }

    function clearSearchResults() {
        filterUtil = new FilterUtils(_defaultFilterCriteria());
        filterDefer = $q.defer();
        req.Paging.PageIndex = 0;
        results = null;
    }

    function getSearchResults(searchId, tripId, selectedFlightId) {
        if (results && searchId === results.AvailabilitySearchId) {
            if (selectedFlightId) {
                const r = _.cloneDeep(results);
                const flights = _.get(r, 'CombinedDates.AvailableFlights');
                _.set(r, 'CombinedDates.AvailableFlights', _.filter(flights, f => f.FlightId !== selectedFlightId));
                return $q.when(r);
            }
            return $q.when(results);
        }
        clearSearchResults();
        return service.search({ searchId, tripId });
    }

    function search(args) {
        if (inProgress != null && !args.newSearch) {
            return inProgress;
        }
        req.AvailabilitySearchId = args.searchId;
        req.TripId = args.tripId;
        req.CombineDates = true;

        if (args.newSearch || args.useSearchUnit || args.isV3HolidayRoute) {
            delete req.SelectedFlight;

            req.Destination = searchUnitService.getDestination();
            req.DestinationAirports = args.newSearch ? searchUnitService.getDestinationAirports() : searchUnitService.getDestinationAirports(req.Destination);
            req.SelectedDestinationAirport = searchUnitService.getDestinationAirport();
            req.DepartureAirports = searchUnitService.getDepartureAirports();
            req.SelectedDepartureAirport = searchUnitService.getSelectedDepartureAirport();
            req.DepartureDate = searchUnitService.startDate(searchUnitService.flight);
            req.ReturnDate = searchUnitService.endDate(searchUnitService.flight);
            const occ = occupancyService.reduceOccupancy();
            req.Adults = occ.Adults;
            req.ChildAges = occ.ChildAges;
            req.Paging.PageIndex = 0;
            req.OneWayOnly = args.oneWayOnly;
            req.FlightOnlySearch = args.flightOnly;
            searchUnitService.setOneWayFlightEnabled(args.oneWayOnly);
            req.Cabin = searchUnitService.getCabin();
            req.PreferredCarrierCodes = args.prefilterAirlines;
            req.IsDirectFlight = args.prefilterDirectFlights;

            if (TRPCONFIG.Domain.isAgentMode && TRPCONFIG.Domain.ShowAgentOfficeSelector) {
                req.OfficeLocationId = $rootScope.agent.CurrentOfficeLocation;
            }
            if (args && args.postfilterAirlines && args.postfilterAirlines.length) {
                getFilter().Airline = args.postfilterAirlines;
            }
            if (!TRPCONFIG.Domain.FlexibleDatesEnabled || !args.flexibleDates) {
                getFilter().DepartureDates = [unadjustedDateFilter(req.DepartureDate, 'yyyy-MM-dd')];
            } else {
                getFilter().DepartureDates = [];
            }
            req.FilterCriteria = _getFilterCriteriaSet();
            tripService.recordFlightSearch(args.tripId, req);
        }

        function get() {
            if (!args.newSearch && args.isV3HolidayRoute) {
                return;
            }
            const whitelist = [
                /^\/holidays\/flights\/\w+/,
                '/holidays/flightunavailable',
                /^\/flights\/\w+/,
                /^\/holidays\/hotels\/\w+/
            ];
            filterCanceller = cancellerService.add.apply(null, whitelist);
            filterCanceller.promise.then(function() {
                inProgress = null;
            });
            const isHotelFirst = JSON.parse(sessionStorage.getItem('PreselectFlight'));
            if (isHotelFirst && !TRPCONFIG.Domain2.IsHotelFirstJourneyEnabled) {
                _resetFlexibleDates(req);
            }
            const prunedReq = pruneRequest(req);
            return $http.post(_getUrl(args.newSearch), prunedReq, { timeout: filterCanceller.promise })
                .then(function(res) {
                    req.AvailabilitySearchId = res.data.AvailabilitySearchId;

                    getFilter().DepartureDates = res.data.FilterCriteria.DepartureDates;

                    filterUtil.copyFilterFrom('PriceRange', res.data.CombinedDates.UnfilteredAggregates);
                    filterUtil.copyFilterFrom('OutboundTakeOffRange', res.data.CombinedDates.UnfilteredAggregates);
                    filterUtil.copyFilterFrom('ReturnTakeOffRange', res.data.CombinedDates.UnfilteredAggregates);

                    if (results) { //we already had results so we are just loading more results
                        results.CombinedDates.AvailableFlights = results.CombinedDates.AvailableFlights.concat(res.data.CombinedDates.AvailableFlights);
                    } else {
                        results = res.data;
                    }

                    inProgress = null;
                    filterDefer.resolve(service.getFilter());

                    if (args.resetPriceRange === true) {
                        _resetPriceRange(results);
                    }

                    broker.publish('flightResultsModified', results);

                    return results;
                });
        }

        inProgress = $q.all([
            args.sortOrder || preferences.getFlightSortOrder(args.newSearch),
            tripService.getFlightsRequest(args.tripId)
        ])
        .then(([so, fr]) => {
            req.SortCriterion = so;
            const selectedFlightId = _.get(fr, 'SelectedFlight.FlightId');
            _.set(req, 'FilterCriteria.SelectedFlightId', selectedFlightId);
        })
        .then(get)
        .catch(() => inProgress = null);

        return inProgress;
    }

    function rehydrateMultiDestHolidayFlight(selectedFlight) {
        const { DetailsId, FlightId } = selectedFlight || {};

        if (DetailsId && FlightId) {
            return flightDetail.rehydrate(DetailsId)
                .then(details => {
                    if (details.Itinerary) {
                        // See holidaySearchCtrl.js
                        details.Itinerary.FlightId = FlightId;
                    }
                    return details;
                });
        }
        return $q.when();
    }

    function setBags(trip, flight) {
        if (flight) {
            return baggageService.getBaggageInfo(trip.TripId).then(function(bagInfo) {
                flight.Legs.forEach((l, i) => {
                    if (l.BagsIncludedCount > 0) {
                        //this means that the leg already comes with bags (though we may not have known this at the time we selected the flight
                        l.passengerBagCount = l.BagsIncludedCount;
                    } else {
                        //if the leg does not include baggage, we use the number of bags that the user has currently selected
                        l.passengerBagCount = bagInfo[i]
                            ? bagInfo[i].holdBagCount
                            : bagInfo[0] && bagInfo[0].holdBagCount || 0;
                    }
                });
                flight.bags = _.max(flight.Legs.map(leg => leg.passengerBagCount));
            });
        }
        return $q.when();
    }

    function modifyBags(numberOfBags) {
        broker.publish('searchCriteriaModified');
        if (results != null) {
            _resetPriceRange(results);
        }
        req.FilterCriteria = _getFilterCriteriaSet();
        req.Paging.PageIndex = 0;
        req.NumberOfLeadBags = numberOfBags;
        results = null;
        return service.search({ searchId: req.AvailabilitySearchId, tripId: req.TripId, resetPriceRange: true });
    }

    function sort(criterion) {
        broker.publish('searchCriteriaModified');
        req.FilterCriteria = _getFilterCriteriaSet();
        req.Paging.PageIndex = 0;
        results = null;
        return preferences.setFlightSortOrder(criterion).then(() => {
            return service.search({ searchId: req.AvailabilitySearchId, tripId: req.TripId, sortOrder: criterion });
        });
    }

    function filter() {
        const filterDeferred = (filterCanceller || $q.defer());
        filterDeferred.resolve();
        broker.publish('searchCriteriaModified');
        req.FilterCriteria = _getFilterCriteriaSet();
        req.Paging.PageIndex = 0;
        results = null;
        return filterDeferred.promise.then(function() {
            return service.search({ searchId: req.AvailabilitySearchId, tripId: req.TripId });
        });
    }

    function getAvailabilityRequest() {
        return req;
    }

    function pageSize() {
        return req.Paging.PageSize;
    }

    function nextPage() {
        req.Paging.PageIndex += 1;
        req.FilterCriteria = _getFilterCriteriaSet();
        return service.search({ searchId: req.AvailabilitySearchId, tripId: req.TripId });
    }

    function getUrl() {
        return url;
    }

    function setCabin(cabin) {
        req.Cabin = cabin;
    }

    function trackFlightClick(
        flight,
        tripId,
        boostReason = null) {
        const _flight = _.partial(_.get, flight);

        analytics.track('mixpanel', 'FlightListingClick', {
            RepeatFlightClicked: _flight('RecentlyViewedIndex') === 1,
            InboundCareer: _flight('Legs[0].Segments[0].CarrierName'),
            OutboundCareer: _flight('Legs[1].Segments[0].CarrierName')
        });

        return tripService.getFlightsRequest(tripId).then(fRequest => {
            let FreeBaggage = _(_flight('Legs')).map(leg => leg.BagsIncludedCount).min() > 0;

            const selectionsReq = {
                Type: 1,
                SearchId: _.get(fRequest, 'AvailabilitySearchId'),
                DomainId: _.get(TRPCONFIG, 'Domain.DomainId'),
                AdultFare: _flight('LeadAdultPrice'),
                AdultTax: _flight('LeadAdultTax'),
                CurrencyCode: _flight('CurrencyCode'),
                FreeBaggage,
                SearchResultsIndex: _flight('SearchResultsIndex'),
                BoostReason: boostReason,
                OutboundDepartureAirport: _flight('Legs[0].DepartureAirport.Code'),
                OutboundDepartureDate: _flight('Legs[0].DepartureDate'),
                OutboundArrivalAirport: _flight('Legs[0].ArrivalAirport.Code'),
                OutboundArrivalDate: _flight('Legs[0].ArrivalDate'),
                OutboundSegmentDetails: _.map(_flight('Legs[0].Segments'), mapSegmentForTracking),
                InboundDepartureAirport: _flight('Legs[1].DepartureAirport.Code'),
                InboundDepartureDate: _flight('Legs[1].DepartureDate'),
                InboundArrivalAirport: _flight('Legs[1].ArrivalAirport.Code'),
                InboundArrivalDate: _flight('Legs[1].ArrivalDate'),
                InboundSegmentDetails: _.map(_flight('Legs[1].Segments'), mapSegmentForTracking)
            };

            localStorage.setItem('flightsSelections', JSON.stringify(selectionsReq));

            return $http.post('/api/useractions/selections', selectionsReq, { ignoreErrors: true });
        });
    }

    function mapSegmentForTracking(s) {
        const _s = _.partial(_.get, s);
        return {
            DepartureAirport: _s('DepartureAirportCode'),
            DepartureDate: _s('DepartureDate'),
            ArrivalAirport: _s('DestinationAirportCode'),
            ArrivalDate: _s('ArrivalDate'),
            FlightNumber: _s('FlightNumber'),
            CarrierName: _s('CarrierName'),
            Cabin: _s('Cabin'),
            AdditionalStops: _s('AdditionalStops')
        };
    }

    function pruneRequest(req) {
        req = _.pick(req,
            'Adults',
            'AvailabilitySearchId',
            'ChildAges',
            'CombineDates',
            'CultureCode',
            'CurrencyCode',
            'DepartureAirports',
            'DepartureDate',
            'Destination',
            'DestinationAirports',
            'DomainId',
            'ExcludeOpenJaw',
            'FilterCriteria',
            'FlightOnlySearch',
            'IsAnyToAny',
            'NumberOfLeadBags',
            'OneWayOnly',
            'Paging',
            'Cabin',
            'ReturnDate',
            'ReturnFullResults',
            'SortCriterion',
            'IsSingleDaySearch',
            'PreferredCarrierCodes',
            'IsDirectFlight',
            'OfficeLocationId',
            'WaitForResults'
        );

        req.Destination = _.pick(req.Destination,
            'CountryId',
            'ProvinceId',
            'LocationId',
            'EstablishmentId',
            'PolygonId'
        );

        req.Paging = _.pick(req.Paging,
            'PageIndex',
            'PageSize'
        );

        req.FilterCriteria = _.pick(req.FilterCriteria,
            'DepartureAirport',
            'Airline',
            'SelectedFlightId',
            'Stop',
            'OutboundTakeOffRange',
            'OutboundLandingRange',
            'ReturnTakeOffRange',
            'ReturnLandingRange',
            'PriceRange',
            'HideAlternativeDates',
            'HideOpenJaw',
            'DepartureDates'
        );

        return req;
    }

    return service;
}
})();
